<template>
  <div class="ads-put-in-auto">
    <div class="header-box">
      <span class="header-label">日期</span>
      <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
        value-format="yyyy-MM-dd" style="width: 230px;">
      </el-date-picker>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <ads-table  :tableData = "tableData"
                :theadList = "theadList"
                @switch-change = "switchChange"
                @input-change = "inputChange">
    </ads-table>
  </div>
</template>

<script>
import adsTable from '_c/table'
import {adsModules} from '@r'
export default {

  data () {
    return {
      tableData: [],
      theadList: [
        {
          id: '1',
          propName: 'index',
          labelName: '序号',
          textAlign: "center",
        },
        {
          id: '2',
          propName: 'status',
          labelName: '有效',
          showSwitch: true,
          activeValue: 1,
          inactiveValue: 2,
        },
        {
          id: '3',
          propName: 'typeText',
          labelName: '自动定位组'
        },
        {
          id: '4',
          propName: '',
          labelName: '匹配类型'
        },
        {
          id: '31',
          propName: 'impressions',
          labelName: '曝光量',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.impressions)-parseFloat(rowB.impressions);
        },
          textAlign: "right",
        },
        {
          id: '32',
          propName: 'clicks',
          labelName: '点击数',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.clicks)-parseFloat(rowB.clicks);
        },
          textAlign: "right",
        },
        {
          id: '33',
          propName: 'clickRate',
          labelName: '点击率',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.clickRate)-parseFloat(rowB.clickRate);
        },
          textAlign: "right",
        },
        {
          id: '5',
          propName: 'servingStatus',
          labelName: '状态'
        },
        {
          id: '6',
          propName: 'bid',
          labelName: '竞价',
          showInput: true,

          textAlign: "right",
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.bid)-parseFloat(rowB.bid);
          }
        },
        {
          id: '11',
          propName: 'averageSpend',
          labelName: '平均点击单价',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.averageSpend)-parseFloat(rowB.averageSpend);
        },
          textAlign: "right",
        },
        {
          id: '7',
          propName: 'spend',
          labelName: '花费',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.spend)-parseFloat(rowB.spend);
        },
          textAlign: "right",
        },
        {
          id: '8',
          propName: 'orders',
          labelName: '订单数',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.orders)-parseFloat(rowB.orders);
        },
          textAlign: "right",
        },
        {
          id: '9',
          propName: 'sales',
          labelName: '销售额',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.sales)-parseFloat(rowB.sales);
        },
          textAlign: "right",
        },
        {
          id: '10',
          propName: 'acos',
          labelName: 'ROAS',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
            let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
            return subNumber - nextNumber;
          },
          textAlign: "right",
          }
      ],
      groupId: null,
      date: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            id: 'yesterday',
            text: '前一天',
            onClick: (picker) => {
              console.log(this);
              const end = this.date[0] || '';
              const start = this.date[1] || '';
              const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
              const newStart =  new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
              picker.$emit('pick', [newStart, newEnd]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  components: {
    adsTable
  },
  created () {

  },
  activated(){
    this.groupId = this.$route.query.groupId;
    const {beginDate, endDate} = this.$route.query;
      (beginDate || endDate) && (this.date = [beginDate, endDate]);
    this.queryAdsList()
  },
  methods: {
    onQueryBtnClick() {
      this.queryAdsList();
    },
    queryAdsList () {
      adsModules.getAdGroupTargetingList({
        // 请求参数
          params:{
            beginIndex: this.beginIndex,
            pageSize: this.pageSize,
            groupId: this.groupId,
            type: 1,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
      }).then((res) => {
        if(res.result !== 1){
          this.$message({
            type: 'error',
            message: res.message ? res.message : '列表数据获取出错'
          });
          return
        }
        this.tableData = res.ldata;
      }).catch((err) => {
        console.log(err)
        this.$message({
            type: 'error',
            message: err.message ? err.message : '列表数据获取出错'
          });
      })
    },
    switchChange (porpName, newVal, scope) {
      console.log('newVal:' + newVal + 'id:' + scope)
      adsModules.updateAdGroupTarget({
        targetId: scope.row.id,
        status: newVal
      }).then((res) => {
        if(res.result !== 1){
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
      }).catch((err) => {
        this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑失败'
          });
      })
    },
    resetSwitch () {
      newVal === 1 ? scope.row.status = 0 : scope.row.status = 1
    },
    inputChange (newVal, scope, propName, oldVal) {
      adsModules.updateAdGroupTarget({
        targetId: scope.row.id,
        bid: newVal
      }).then((res) => {
        if(res.result !== 1){
          this.resetInput(newVal, scope, propName, oldVal);
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
      }).catch((err) => {
        this.resetInput(newVal, scope, propName, oldVal);
        this.$message({
          type: 'error',
          message: err.message ? err.message : '编辑失败'
        });
      })
    },
    resetInput (newVal, scope, propName, oldVal){
      scope.row[propName] = oldVal;
    },
  }
}
</script>

<style lang="scss">
.header-box{
  .el-button{
    width: auto;
  }
}
</style>
